import { combineReducers } from "redux";

import common from "../features/admin/common/Slice";

const common_masters = combineReducers({
  common,
});

export default common_masters;
